import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Result } from 'antd';

const PurchaseSuccess = () => (
  <Result
    status="success"
    title={[<h1>Payment Successful!</h1>]}
    style={{justifySelf:"center", marginTop:" 10%",}}
    subTitle="Calculations will be credited to your account."
    extra={[
    <NavLink to='/home'>
      <Button type="primary" key="console">
       Return to Homepage
      </Button>
    </NavLink>    
    ]}
  />
);
export default PurchaseSuccess;